import React from 'react';
import { Redirect } from 'react-router-dom';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import { TagsService } from '../../services';

import config from "config";

class TagView extends React.Component {

  constructor(props) {
    super(props);

    const tag = {
      name: null
    };

    this.state = {
      added: null,
      tag: null,
      tagId: props.match.params.tagId,
      errorMessage: null,
      localErrorMessage: null
    };

    this.messageDismissCallback = this.messageDismissCallback.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    e.preventDefault();
  }

  componentDidMount() {
    TagsService.get(this.state.tagId).then((response) => {
      this.setState({ tag: response.tag });
    }).catch((error) => {
      console.error(error);
      this.setState({ errorMessage: i18next.t('messages.could-not-load-tag-view') });
    });
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
        <Message
          errorMessage={this.state.localErrorMessage}
          messageDismissCallback={this.messageDismissCallback}
        />
      );
    }
    return null;
  }

  render() {
    const id = this.state.tagId;

    if (this.state.errorMessage) {
      return (
        <Redirect to={{
          pathname: '/admin/tags',
          state: {
            errorMessage: this.state.errorMessage
          }
        }}
        />
      );
    }

    if (this.state.tag) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div className = "tag-view tag-form">
            {this.renderMessages()}
            <div className="row">
              <PageTitle title={`${this.state.tag.name}`}
                         backLinkWithParams={{
                           link: {
                             pathname: "/admin/tags",
                             search: backLinkSearch
                           }
                         }}
                       />
            </div>

            <div className="op-content-box">
              <div className="row">
                <div className="col-sm-6 col-md-4 form-group">
                  <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                    <label>{i18next.t('form-labels.name')}</label><p>{this.state.tag.name}</p>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 form-group">
                  <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-name">
                    <label>{i18next.t('pages.tags.tag-type')}</label><p>{i18next.t(`tag-types.${this.state.tag.tagType.token}`)}</p>
                  </div>
                </div>
                <div className="pull-right tooltip edit-pencil">
                    <Link to = {{
                      pathname: `/admin/tags/edit/${this.state.tag.id}`,
                      state: {
                        backLinkSearch: backLinkSearch
                      }
                    }}><img style={{paddingRight: 15}} src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/pencil.svg`}/></Link>
                    <span className="tooltiptext">{i18next.t('edit')}</span>
                </div>
              </div>

              <div className="panel-heading">
                <b>{i18next.t('table-headers.thresholds')}</b> ({this.state.tag.thresholds.length})
              </div>

              <div className="react-table-custom">
                <ReactTable
                  className="-striped -highlight"
                  ref="thresholdTable"
                  data={this.state.tag.thresholds}
                  defaultPageSize = {10}
                  showPaginationTop
                  columns={[
                              {
                                Header: i18next.t('table-headers.name'),
                                accessor: "name",
                                sortable: true,
                                minResizeWidth: 50
                              }
                            ]}
                />
              </div>

              <div className="panel-heading">
                <b>{i18next.t('table-headers.devices')}</b> ({this.state.tag.devices.length})
              </div>

              <div className="react-table-custom">
                <ReactTable
                  className="-striped -highlight"
                  ref="devicesTable"
                  data={this.state.tag.devices}
                  defaultPageSize = {10}

                  showPaginationTop
                  columns={[
                              {
                                Header: i18next.t('table-headers.name'),
                                accessor: "displayName",
                                sortable: true,
                                minResizeWidth: 50
                              },
                              {
                                Header: i18next.t('table-headers.location'),
                                accessor: "deviceGrouping.name",
                                sortable: true,
                                minResizeWidth: 50
                              }
                            ]}
                />
              </div>

              {this.state.tag.tagType.token === 'checklist-passive-device' &&
              <div>
                <div className="panel-heading">
                <b>{i18next.t('table-headers.checklists')}</b> ({this.state.tag.checklistSteps.length})
                </div>

                <div className="react-table-custom">
                  <ReactTable
                    className="-striped -highlight"
                    ref="devicesTable"
                    data={this.state.tag.checklistSteps}
                    defaultPageSize = {10}
                    showPaginationTop
                    columns={[
                                {
                                  Header: i18next.t('table-headers.checklist'),
                                  accessor: "checklistConfigName",
                                  sortable: true,
                                  minResizeWidth: 50
                                },
                                {
                                  Header: i18next.t('table-headers.task'),
                                  accessor: "checklistTaskConfigName",
                                  sortable: true,
                                  minResizeWidth: 50
                                }
                              ]}
                  />
                </div>
            </div>
            }
            </div>
          </div>
        );
    }
    return (
      <div className="loader">{i18next.t('loading')}</div>
    );
  }

}

export default TagView;
